import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@modules/shared.module';
import { AlertsPageComponent } from '@pages/alerts/alerts.page';
import { UiGridResetModule } from '@pages/generics/grid/grid-reset';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiDateFormatModule } from '@uipath/angular/directives/ui-dateformat';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';

import { AlertDetailsModalComponent } from './alert.details.modal';

const MODALS = [
    AlertDetailsModalComponent,
];

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        UiGridModule,
        UiGridResetModule,
        UiNgLetModule,
        UiDateFormatModule,
    ],
    declarations: [
        AlertsPageComponent,
        ...MODALS,
    ],
    exports: [
        AlertsPageComponent,
    ],
    entryComponents: [
        ...MODALS,
    ],
})
export class AlertModule { }
